import { useRoutes } from "react-router-dom";
import Dashboard from ".";
import LogoutPage from "../../components/LogoutPage";
import Sidebar from "../../components/SideBar";
import AssesmentResults from "../AssesmentResults";
import BillingPaymentPage from "../BillingPaymentPage";
import BookingStepper from "../BookingStepper";
import UserProfile from "../UserProfile";
import HelpSupport from "../HelpSupport";
const DashboardRoot = () => {
  let routes = useRoutes([
    { path: "", element: <Dashboard /> },
    { path: "appointments", element: <BookingStepper /> },
    { path: "assessments", element: <AssesmentResults /> },
    { path: "profile", element: <UserProfile /> },
    { path: "help", element: <HelpSupport /> },
    { path: "billing", element: <BillingPaymentPage /> },
    { path: "logout", element: <LogoutPage /> },
  ]);

  return (
    <div className="flex flex-col items-center justify-center bg-gray-100 w-full">
      <div className="flex flex-col md:flex-row w-full h-screen overflow-hidden">
        <div className="w-1/4 bg-grey-100">
          <Sidebar />
        </div>
        <div className="w-full bg-gray-100 overflow-auto">{routes}</div>
      </div>
    </div>
  );
};

export default DashboardRoot;
